
export const LOGIN = `/api/login`;
export const ACCESS_CODE = `/api/access_code/send`;
export const TOKEN_REFRESH = `/api/mobile/token/refresh`;
export const LOGOUT = `/api/logout`;
export const CHECK_EMAIL = (email) => `/api/check_email/${encodeURIComponent(email)}`;
export const LOGIN_EXTERNAL = `/api/mobile/login_external`;

